import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import Footer from '../../components/Footer';
import 'wicg-inert';
import ScrollToTop from "../../libs/scrollToTop";
import { useKonami } from 'react-konami-code';
import Nav from '../../components/Nav.js';
import SecondaryNav from '../../components/SecondaryNav';

import { fireTag } from '../../libs/analytics.js';

import heroMobileImage from '../../images/articles/wf-isf-sustainability-trends-for-2024_767x577.jpg';
import heroDesktopImage from '../../images/articles/wf-isf-sustainability-trends-for-2024_1164x584.jpg';

import ModalOverlay from "../../components/ModalOverlay";

const Trends = ({
				handleEvent,
				modalOverlay,
				closeExitOverlay,
				addExitClickListeners,
			}) => {

	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const [gridVisible, setGridVisible] = useState(false);
	const heroOGImage = 'wf-isf-sustainability-trends-for-2024_ogimage.jpg';

	addExitClickListeners();

	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	const linkDisclosures = () => {
		const bodyDisclosures = document.querySelectorAll('.body-disclosures');
		const footerDisclosures = document.querySelectorAll('.footer-disclosures');
		bodyDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = footerDisclosures[disclosureNumber - 1];
				fireTag('A2',disclosureNumber);
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});

				window.setTimeout(() => {
					// console.log(' ======== ');
					// console.log(targetElement);
					targetElement.focus();
				}, 1000);

			});
		});

		footerDisclosures.forEach(elem => {
			elem.addEventListener('click', (e) => {
				e.preventDefault();
				let disclosureNumber = Number(e.target.innerHTML)
				let targetElement = bodyDisclosures[disclosureNumber - 1];
				window.scrollTo({
					left: 0,
					top: targetElement.offsetTop,
					behavior: 'smooth'
				});
				window.setTimeout(() => {
					targetElement.focus();
				}, 1000);
			});
		});
	}


	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)
		linkDisclosures();

	}, []); // empty array says only use this effect once

	let mastheadImage;
	let bodyImage;

	switch (true) {
		case (window.innerWidth < 768):
			mastheadImage = heroMobileImage;
			break;
		case (window.innerWidth < 1440):
			mastheadImage = heroDesktopImage;
			break;
		case (window.innerWidth >= 1440):
			mastheadImage = heroDesktopImage;
			break;
	}

	return (
		<>
			<Helmet>
				<title>Top 10 sustainability trends for 2024</title>
				<meta
					name="description"
					content="Wells Fargo’s Corporate & Investment Banking shares insights on sustainability trends and their real-world impacts."
				/>
				<meta property="og:title" content="Top 10 sustainability trends for 2024"/>
				<meta
					property="og:description"
					content="Wells Fargo’s Corporate & Investment Banking shares insights on sustainability trends and their real-world impacts."
				/>
				<meta property="og:image" content="https://welcome.wf.com/impact/images/articles/wf-isf-sustainability-trends-for-2024_ogimage.jpg"/>
				<meta property="og:url" content={`https://welcome.wf.com/impact/sustainability/sustainability-trends-for-2024/`}/>
				<meta property="twitter:title" content="Top 10 sustainability trends for 2024"/>
				<meta
					property="twitter:description"
					content="Wells Fargo’s Corporate & Investment Banking shares insights on sustainability trends and their real-world impacts."
				/>
			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}

			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="articles" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>

			{!window.innerWidth < 768 && (
				<SecondaryNav page="Articles" shouldBeInert={shouldBeInert} activePage="articles"/>
			)}
			<main className='flex-container' >
				<div className="flex-row">
					<div className="flex-col-sm-12 flex-col-md-8 text-center headline">
						<h1 id="articles-main-h1" style={{marginBottom: 10}}>
							Top 10 sustainability trends for 2024
						</h1>
						<h2 className="summary">
							Wells Fargo’s Corporate & Investment Banking team shares insights on sustainability trends and their real-world impacts.
						</h2>
					</div>

				</div>

				<div className="flex-row full-width-md">
					<div className="flex-col-lg-10 flex-col-md-10 text-center hero-container">
						<img src={mastheadImage} alt="Two businessmen stand in a vineyard with solar panels in the background."/>
					</div>
				</div>

				<div className="flex-row">
					<div className="flex-col-md-8 flex-col-sm-12 text-center article-intro info-graphic">
						<div className="by-line">
							<p>by Readie Callahan, <span>managing director, sustainable finance and advisory at Wells Fargo, Corporate & Investment Banking</span></p>
						</div>
						<div className="article-info">
							<div>
								<p>February 21, 2024</p>
							</div>
							<div>
								<p>2-minute read</p>
							</div>
						</div>
						<p>
							The complexity of a global energy transformation and drive for equitable solutions became clear in 2023. As we look to 2024, companies and governments will continue to contend with the real-world challenges and opportunities of achieving their sustainability objectives. Projects across the globe have been challenged by a confluence of macro factors such as inflation, interest rates, supply chains, labor dynamics, and permitting hurdles. However, there may be glimmers of a reprieve in 2024 from the macro storm, while largely supportive government policies, broad investor attention, and maturing technologies are expected to continue providing healthy tailwinds.
						</p>
						<p>
							The regulatory environment garnered significant attention last year as it became increasingly dynamic and detailed, with the advancement of rules and guidelines likely continuing this year across European jurisdictions, APAC countries, and across U.S. cities, states, and federal agencies. Emerging areas of sustainability will continue to grow in sophistication, such as nature-based solutions, water management, and the understanding of impacts and reliance upon biodiversity.
						</p>
						<p>
							Meanwhile, the financial markets will grapple with the nuances of an emerging carbon market, and sustainable finance will surely evolve into new structures to meet issuer and investor needs.
						</p>

						<p>
							Read the full list: <a onClick={()=>fireTag('A1','top 10 sustainability trends for 2024')}target="_blank" href="https://www08.wellsfargomedia.com/assets/pdf/cib/insights/2024-top-trends-sustainability.pdf" rel="noreferrer" data-click-listener="false">Top 10 Sustainability Trends for 2024</a>.
						</p>
					</div>
				</div>
				{/*<KonamiElement className="grid"/>*/}
			</main>
			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>
			{/* Adobe retargeting tag */
			}
			{
				/*
					REMOVE TAG
					<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
				*/
			}

			{
				modalOverlay && modalOverlay.open && (
					<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
				)
			}
		</>
	);
};

export default withRouter(Trends);
